/**
 * Age Gate Module
 * Pede confirmação de idade até o visitante aceitar.
 * - "Lembrar" marcado: cookie válido por N dias (data-remember-days na seção).
 * - "Lembrar" desmarcado: cookie de sessão (vale até fechar o navegador).
 */

(function() {
  'use strict';

  const AGE_GATE_COOKIE_NAME = 'age_verified';
  const DEFAULT_REMEMBER_DAYS = 30;

  class AgeGate {
    constructor() {
      this.modal = document.getElementById('age-gate');
      if (!this.modal) return;

      this.acceptButton = this.modal.querySelector('[data-age-gate-accept]');
      this.declineButton = this.modal.querySelector('[data-age-gate-decline]');
      this.rememberCheckbox = document.getElementById('age-gate-remember');
      this.declineMessage = this.modal.querySelector('[data-age-gate-decline-message]');
      this.rememberDays = parseInt(this.modal.dataset.rememberDays, 10) || DEFAULT_REMEMBER_DAYS;
      this.declineUrl = this.modal.dataset.declineUrl || 'https://www.google.com';

      this.init();
    }

    init() {
      if (this.getCookie(AGE_GATE_COOKIE_NAME)) {
        document.documentElement.classList.remove('age-gate-pending');
        return;
      }

      this.show();

      this.acceptButton.addEventListener('click', () => this.handleAccept());
      this.declineButton.addEventListener('click', () => this.handleDecline());
    }

    show() {
      this.previouslyFocused = document.activeElement;
      this.modal.classList.add('is-active');
      this.modal.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      this.acceptButton.focus();

      this.trapFocus = (e) => {
        if (e.key !== 'Tab') return;
        const focusable = this.modal.querySelectorAll('button:not([disabled]), input:not([disabled])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', this.trapFocus);
    }

    hide() {
      this.modal.classList.remove('is-active');
      this.modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('age-gate-pending');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.trapFocus);
      if (this.previouslyFocused && this.previouslyFocused.focus) this.previouslyFocused.focus();
    }

    handleAccept() {
      const remember = this.rememberCheckbox && this.rememberCheckbox.checked;
      this.setCookie(AGE_GATE_COOKIE_NAME, 'true', remember ? this.rememberDays : null);
      this.hide();
    }

    handleDecline() {
      this.acceptButton.disabled = true;
      this.declineButton.disabled = true;
      if (this.declineMessage) this.declineMessage.hidden = false;
      setTimeout(() => {
        window.location.href = this.declineUrl;
      }, 2500);
    }

    setCookie(name, value, days) {
      // Sem "domain": o cookie vale para o domínio atual (loja, www, *.myshopify.com e preview).
      let cookie = `${name}=${value}; path=/; SameSite=Lax`;
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        cookie += `; expires=${date.toUTCString()}`;
      }
      if (window.location.protocol === 'https:') cookie += '; Secure';
      document.cookie = cookie;
    }

    getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let c of ca) {
        c = c.trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
      }
      return null;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new AgeGate());
  } else {
    new AgeGate();
  }

})();
